<template>
  <section class="section section--intro" id="intro">
    <div class="section__inner">
      <div class="block">
        <a class="pre" href="#intro"> <span>#1</span>Intro </a>
        <h1>
          Snowie is a
          <br />Web Developer <br />currently based in <br />Michigan, United
          States.
        </h1>
        <p class="lead">
          View bytes of her code
          <a href="https://github.com/snowiesuet" class="link">Github</a>, quick
          thoughts on
          <a href="https://twitter.com/serenites" class="link">Twitter</a>, and
          companies she worked with on
          <a href="https://www.linkedin.com/in/snowieleung/" class="link"
            >Linkedin</a
          >.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Intro"
};
</script>

<style lang="scss">
.section--intro {
  background-color: white;
  color: $black;
}
</style>
